import React, { useState, useEffect } from 'react';
import { XMarkIcon } from '@heroicons/react/24/outline';

const LeadModal = ({ lead, onSave, onClose, formData, setFormData }) => {
  // If formData and setFormData are provided from parent, use them
  // Otherwise, use local state (for backward compatibility)
  const [localFormData, setLocalFormData] = useState({
    name: '',
    phone: '',
    source: ''
  });

  // Use parent formData if provided, otherwise use local state
  const currentFormData = formData || localFormData;
  const setCurrentFormData = setFormData || setLocalFormData;

  useEffect(() => {
    if (lead) {
      const newFormData = {
        name: lead.name || '',
        phone: lead.phone || '',
        source: lead.source || ''
      };
      setCurrentFormData(newFormData);
    }
  }, [lead, setCurrentFormData]);

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave(currentFormData);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setCurrentFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  return (
    <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-50">
      <div className="relative top-20 mx-auto p-5 border w-96 shadow-lg rounded-md bg-white">
        <div className="mt-3">
          <div className="flex justify-between items-center mb-4">
            <h3 className="text-lg font-medium text-gray-900">
              {lead ? 'Edit Lead' : 'Add New Lead'}
            </h3>
            <button
              onClick={onClose}
              className="text-gray-400 hover:text-gray-600"
            >
              <XMarkIcon className="h-6 w-6" />
            </button>
          </div>

          <form onSubmit={handleSubmit} className="space-y-4">
            {/* Name Field */}
            <div>
              <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1">
                Name *
              </label>
              <input
                type="text"
                id="name"
                name="name"
                value={currentFormData.name}
                onChange={handleChange}
                required
                className="input-field"
                placeholder="Enter lead name"
              />
            </div>

            {/* Mobile Field */}
            <div>
              <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-1">
                Mobile Number *
              </label>
              <input
                type="tel"
                id="phone"
                name="phone"
                value={currentFormData.phone}
                onChange={handleChange}
                required
                className="input-field"
                placeholder="Enter mobile number"
              />
            </div>

            {/* Source Field */}
            <div>
              <label htmlFor="source" className="block text-sm font-medium text-gray-700 mb-1">
                Source of Lead *
              </label>
              <select
                id="source"
                name="source"
                value={currentFormData.source}
                onChange={handleChange}
                required
                className="input-field"
              >
                <option value="">Select Source</option>
                <option value="Website">Website</option>
                <option value="Google Search">Google Search</option>
                <option value="Social Media">Social Media</option>
                <option value="WhatsApp Lead">WhatsApp Lead</option>
                <option value="Referral">Referral</option>
                <option value="Advertisement">Advertisement</option>
                <option value="Cold Call">Cold Call</option>
                <option value="Other">Other</option>
              </select>
            </div>

            <div className="flex justify-end space-x-3 pt-4">
              <button
                type="button"
                onClick={onClose}
                className="btn-secondary"
              >
                Cancel
              </button>
              <button
                type="submit"
                className="btn-primary"
              >
                {lead ? 'Update Lead' : 'Create Lead'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default LeadModal;

